// extracted by mini-css-extract-plugin
module.exports = {"hand":"Hand_hand__1nT-Y","options":"Hand_options__3Pota"};